import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserData } from '../_models/users';
import { NotificationService } from '../_services/notification.service';
import { ChecksService } from '../_services/checks.service';
import { ApiService } from '../_services/api.service';
import { AdminData } from '../_models/admin';
import { DealslipDashboard } from '../_models/dealslip';
import { HrDepartmentData, HrDesignationData, HrLeaveData, HrOrganogramData, HrStaffData } from '../_models/hr';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {
  userData: AdminData;
  auth: number;
  notificationCount: number = 0;

  userist: UserData[] = [];
  dealslipDashboard: DealslipDashboard;
  hrStaffList: HrStaffData[] = [];
  hrDepartmentList: HrDepartmentData[] = [];
  hrDesignationList: HrDesignationData[] = [];
  hrLeaveList: HrLeaveData[] = [];
  hrOrganogramList: HrOrganogramData[] = [];

  pageUrl = this.router.url.slice(1);

  constructor(
    public checkService: ChecksService,
    private apiService: ApiService,
    private notifyService: NotificationService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.userData = this.checkService.checkSession();
    this.auth = parseInt(localStorage.getItem('auth'));
    this.dealslipDashboard = new DealslipDashboard();
    
    this.getUserKyc();
    this.getDealslipDashboard();
    this.getHrDashboardData();
  }


  getUserKyc() {
    this.apiService.getUserKyc(2, "").subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        if (data.success == true) {
          this.userist = data.data;
        } else {
          this.notifyService.showError(data.error.message, "Error")
        }
      }
    );
  }

  getDealslipDashboard() {
    this.apiService.dealslipDashboard({}).subscribe(
      data => {
        this.checkService.checkLoggedin(data);
        if (data.success == true) {
          this.dealslipDashboard = data;
        } else {
          this.notifyService.showError(data.error.message, "Error");
        }
      }
    );
  }

  getHrDashboardData() {
    if (this.checkService.canRead(['hr.staff', 'users'])) {
      this.apiService.getHrStaff(1).subscribe(data => {
        this.checkService.checkLoggedin(data);
        if (data.success == true) {
          this.hrStaffList = data.data || [];
        }
      });
    }

    if (this.checkService.canRead(['hr.department', 'hr.staff', 'users'])) {
      this.apiService.getHrDepartments(1).subscribe(data => {
        this.checkService.checkLoggedin(data);
        if (data.success == true) {
          this.hrDepartmentList = data.data || [];
        }
      });
    }

    if (this.checkService.canRead(['hr.designation', 'hr.staff', 'users'])) {
      this.apiService.getHrDesignations(1).subscribe(data => {
        this.checkService.checkLoggedin(data);
        if (data.success == true) {
          this.hrDesignationList = data.data || [];
        }
      });
    }

    if (this.checkService.canRead(['hr.leave', 'hr.staff', 'users'])) {
      this.apiService.getHrLeaves(1).subscribe(data => {
        this.checkService.checkLoggedin(data);
        if (data.success == true) {
          this.hrLeaveList = data.data || [];
        }
      });
    }

    if (this.checkService.canRead(['hr.organogram', 'hr.staff', 'users'])) {
      this.apiService.getHrOrganogram().subscribe(data => {
        this.checkService.checkLoggedin(data);
        if (data.success == true) {
          this.hrOrganogramList = data.data || [];
        }
      });
    }
  }

  printName(details:UserData) {
    return (details.companyDetails.ref == 0)? details.firstName + " " + details.lastName : details.companyDetails.name
  }

  totalEntities() {
    const stats = this.userData?.stats?.users;
    if (!stats) {
      return 0;
    }

    return (stats.new || 0) + (stats.pending || 0) + (stats.complete || 0) + (stats.active || 0) + (stats.inactive || 0);
  }

  totalKycWork() {
    const stats = this.userData?.stats?.users;
    if (!stats) {
      return 0;
    }

    return (stats.new || 0) + (stats.pending || 0);
  }

  statusPercent(value: number) {
    const total = this.dealslipDashboard?.data?.totalDeals || 0;
    if (total < 1) {
      return 0;
    }

    return Math.round(((value || 0) / total) * 100);
  }

  topSellCurrency() {
    return this.dealslipDashboard?.data?.sellCurrency?.[0];
  }

  topBuyCurrency() {
    return this.dealslipDashboard?.data?.buyCurrency?.[0];
  }

  hasHrWidgets() {
    return this.checkService.canRead(['hr.staff', 'users'])
      || this.checkService.canRead(['hr.leave', 'hr.staff', 'users'])
      || this.checkService.canRead(['hr.department', 'hr.staff', 'users'])
      || this.checkService.canRead(['hr.designation', 'hr.staff', 'users'])
      || this.checkService.canRead(['hr.organogram', 'hr.staff', 'users']);
  }

  hrStatusCount(list: any[], status: string) {
    return (list || []).filter(row => this.matchesStatus(row?.status, status)).length;
  }

  staffWithAdminCount() {
    return (this.hrStaffList || []).filter(staff => !!staff.admin).length;
  }

  staffWithCorporateEmailCount() {
    return (this.hrStaffList || []).filter(staff => !!staff.c_email).length;
  }

  recentActivities() {
    const firstStaff = this.hrStaffList?.[0];
    const firstKyc = this.userist?.[0];
    return [
      {
        initial: this.initials(firstStaff?.firstName || firstStaff?.lastName || 'S'),
        title: 'Employee added',
        subtitle: firstStaff ? this.staffName(firstStaff) : 'HR Team',
        time: '2 min ago',
        className: 'activity-avatar avatar-blue',
      },
      { initial: 'M', title: 'Access granted', subtitle: 'Module access', time: '14 min ago', className: 'activity-avatar avatar-purple' },
      { initial: 'F', title: 'Invoice created', subtitle: 'Finance Team', time: '1 hr ago', className: 'activity-avatar avatar-orange' },
      {
        initial: this.initials(this.printName(firstKyc || new UserData())),
        title: 'KYC completed',
        subtitle: firstKyc ? this.printName(firstKyc) : 'Compliance Desk',
        time: '2 hr ago',
        className: 'activity-avatar avatar-mint',
      },
      { initial: 'T', title: 'Trade recorded', subtitle: 'Treasury Desk', time: '3 hr ago', className: 'activity-avatar avatar-green' },
    ];
  }

  approvalRows() {
    const leave = this.hrLeaveList?.[0];
    return [
      { id: 'APR-001', type: 'Access Request', requestedBy: 'Daniel Kim', department: 'Engineering', status: 'Pending', badgeClass: 'figma-badge badge-pending', date: 'Jun 26', route: ['/settings', 'administrator'] },
      { id: 'APR-002', type: 'Expense Report', requestedBy: 'Priya Nair', department: 'Marketing', status: 'Under Review', badgeClass: 'figma-badge badge-review', date: 'Jun 26', route: ['/hr', 'expenses-approvals'] },
      { id: 'APR-003', type: 'Document Access', requestedBy: 'James Wu', department: 'Legal', status: 'Pending', badgeClass: 'figma-badge badge-pending', date: 'Jun 25', route: ['/settings', 'document'] },
      {
        id: 'APR-004',
        type: 'Annual Leave',
        requestedBy: leave?.staff?.name || 'Elena Vasquez',
        department: leave?.staff?.department?.name || 'Operations',
        status: 'Approved',
        badgeClass: 'figma-badge badge-approved',
        date: 'Jun 25',
        route: ['/hr', 'leave-management'],
      },
    ];
  }

  private initials(value: string) {
    return String(value || 'A').trim().slice(0, 1).toUpperCase();
  }

  private staffName(staff: HrStaffData) {
    return [staff?.firstName, staff?.lastName].filter(Boolean).join(' ') || staff?.employeeNumber || 'New employee';
  }

  private matchesStatus(value: any, status: string) {
    if (!value) {
      return status === 'active';
    }

    if (typeof value === 'string') {
      return value.toLowerCase() === status;
    }

    return value[status] === true;
  }
}
